import React from 'react';

import { SVGPropsType } from 'src/types';

function Search(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M9.09093 15.4546C12.6055 15.4546 15.4546 12.6055 15.4546 9.09093C15.4546 5.57639 12.6055 2.72729 9.09093 2.72729C5.57639 2.72729 2.72729 5.57639 2.72729 9.09093C2.72729 12.6055 5.57639 15.4546 9.09093 15.4546Z"
                stroke={stroke}
                strokeWidth="1.50857"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.2728 17.2728L13.6365 13.6365"
                stroke={stroke}
                strokeWidth="1.50857"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Search;
